import { IconNames } from "@repo/core/components/core/Icon/types";
import { SalesSummaryCardProps } from "./types";

export const getIconAndColorByType = (
  type: SalesSummaryCardProps["type"]
): { icon: IconNames; color: string } => {
  switch (type) {
    case "success": {
      return {
        icon: "dollar-sign",
        color: "$success300"
      };
    }
    case "pending":
      return {
        icon: "clock",
        color: "$warning300"
      };
    case "cancelled":
      return {
        icon: "circle-xmark",
        color: "$error300"
      };

    default:
      return {
        icon: "dollar-sign",
        color: "$success500"
      };
  }
};
